import { Box, Grid, SxProps, Theme, Typography } from "@mui/material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionSubtitle } from "src/modules/SectionSubtitle/SectionSubtitle";

export const Comparison = () => {
  return (
    <SectionContainer sx={{ background: "white" }}>
      <SectionTitle>従来型MSPとテクノスタンダードAMSPの違い</SectionTitle>
      <SectionSubtitle>従来の運用保守の枠を超え、ビジネス成長に貢献する包括的なサポートを提供</SectionSubtitle>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box sx={comparisonCardSx}>
            <Typography variant="h3" sx={traditionalTitleSx}>
              従来のMSPサービス
            </Typography>
            <Box sx={comparisonItemSx}>
              <Typography variant="h4" sx={comparisonItemTitleSx}>
                基本的な監視のみ
              </Typography>
              <Typography variant="body2" sx={comparisonItemDescriptionSx}>
                事前定義されたメトリクスに基づく限定的な監視。潜在的な問題や複雑な異常を見落とすリスクがありました。
              </Typography>
            </Box>
            <Box sx={comparisonItemSx}>
              <Typography variant="h4" sx={comparisonItemTitleSx}>
                手動での問い合わせ対応
              </Typography>
              <Typography variant="body2" sx={comparisonItemDescriptionSx}>
                返答に時間がかかり、既知の問題に限定されがち。エンジニアの稼働時間に依存するため、緊急時の対応が遅れることもありました。
              </Typography>
            </Box>
            <Box sx={comparisonItemSx}>
              <Typography variant="h4" sx={comparisonItemTitleSx}>
                限定的なサービス範囲
              </Typography>
              <Typography variant="body2" sx={comparisonItemDescriptionSx}>
                標準メニュー外の複雑な問題は別途費用や契約が必要で、予期せぬコストや契約手続きの負担がありました。
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={technoCardSx}>
            <Typography variant="h3" sx={technoTitleSx}>
              テクノスタンダードのAMSP
            </Typography>
            <Box sx={technoItemSx}>
              <Typography variant="h4" sx={comparisonItemTitleSx}>
                AIによる高度な自動監視
              </Typography>
              <Typography variant="body2" sx={comparisonItemDescriptionSx}>
                AIが過去のデータやパターンから異常を自動検知し、問題発生前にプロアクティブに対応。ダウンタイムを最小限に抑制します。
              </Typography>
            </Box>
            <Box sx={technoItemSx}>
              <Typography variant="h4" sx={comparisonItemTitleSx}>
                AIが一次対応、ハイエンドエンジニアへ連携
              </Typography>
              <Typography variant="body2" sx={comparisonItemDescriptionSx}>
                生成AIが定型的な問い合わせを迅速に処理し、複雑な問題はハイエンドエンジニアにスムーズに引き継ぎ。解決時間を大幅短縮します。
              </Typography>
            </Box>
            <Box sx={technoItemSx}>
              <Typography variant="h4" sx={comparisonItemTitleSx}>
                ハイエンドエンジニアによる柔軟な対応
              </Typography>
              <Typography variant="body2" sx={comparisonItemDescriptionSx}>
                標準メニュー外の突発的な課題や高度な要件、アーキテクチャの改善提案など、ビジネス成長に貢献する幅広い領域に対応可能です。
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </SectionContainer>
  );
};

const comparisonCardSx: SxProps<Theme> = {
  background: "white",
  padding: "40px",
  borderRadius: "15px",
  boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
  borderLeft: "5px solid #dc3545",
};

const technoCardSx: SxProps<Theme> = {
  background: "linear-gradient(135deg, #f8fff9 0%, #e8f5e8 100%)",
  padding: "40px",
  borderRadius: "15px",
  boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
  borderLeft: "5px solid #28a745",
};

const traditionalTitleSx: SxProps<Theme> = {
  color: "#dc3545",
  fontSize: "1.5rem",
  marginBottom: "25px",
  fontWeight: 600,
};

const technoTitleSx: SxProps<Theme> = {
  color: "#28a745",
  fontSize: "1.5rem",
  marginBottom: "25px",
  fontWeight: 600,
};

const comparisonItemSx: SxProps<Theme> = {
  marginBottom: "20px",
  padding: "15px",
  borderRadius: "8px",
  background: "#f8f9fa",
};

const technoItemSx: SxProps<Theme> = {
  marginBottom: "20px",
  padding: "15px",
  borderRadius: "8px",
  background: "rgba(40,167,69,0.1)",
};

const comparisonItemTitleSx: SxProps<Theme> = {
  fontSize: "1.1rem",
  marginBottom: "10px",
  color: "#1a1a2e",
  fontWeight: 600,
};

const comparisonItemDescriptionSx: SxProps<Theme> = {
  color: "#666",
  fontSize: "0.95rem",
  lineHeight: 1.6,
};
